import { words } from "@admin/traces/traceFormat";
import { useSessionKey } from "@auth/sessionStore";

import { useRoomEvents } from "./perceptionQueries";
import { ago } from "./words";

/**
 * What Brian emitted about the room (BRI-270), newest first, so a tester can
 * note in the ground truth what was wrong. A door move shows once confirmed,
 * up to about 30 s after it happened.
 */
export const RoomEvents = ({
  roomId,
  active,
  now,
}: {
  roomId: string;
  active: boolean;
  now: number;
}) => {
  const events = useRoomEvents(useSessionKey(), roomId, active);
  if (events.isPending) return null;
  return (
    <section
      aria-label="What Brian emitted"
      className="flex flex-col gap-1 border-t border-rule px-3 py-2"
    >
      <h3 className="text-mono-caps text-fine-print text-annotation">
        What Brian emitted
      </h3>
      {events.isError && (
        <p className="text-sm text-ink-stopped">
          I couldn’t load what Brian emitted.
        </p>
      )}
      {events.data?.length === 0 && (
        <p className="text-sm text-annotation">
          Nothing emitted about this room in the last 3 hours.
        </p>
      )}
      <ul data-dd-privacy="hidden" className="flex flex-col gap-0.5 text-sm">
        {events.data?.map((event) => (
          <li key={event.uuid} className="flex min-w-0 gap-2">
            <span className="shrink-0 text-annotation">
              {ago(event.occurred_at, now)}
            </span>
            <span className="shrink-0 text-annotation">
              {words(event.kind)}
            </span>
            <span className="truncate text-ink">{event.line}</span>
          </li>
        ))}
      </ul>
    </section>
  );
};
